module.exports = __webpack_public_path__ + "static/media/matilde-happy.9f002140.png";